// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vxe-modal--wrapper .vxe-modal--content > div[data-v-f6bfd2a2] {\n  height: auto !important;\n}\n.bottom-control[data-v-f6bfd2a2] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
